// removed by extract-text-webpack-plugin
module.exports = {"container":"_3gUOyi6ywIXbkyR_UrV1XY"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/List/Markets/Mobile/Variation/styles.css
// module id = 1613
// module chunks = 85